import React from "react";
import { format, sanitize } from "./Helper";

export const CurrencyInput = ({
  label,
  code,
  flag,
  symbol,
  amount,
  editable,
  onChange,
  onFocus
}) => {
  return (
    <div className="currency-box">
      <span className="label">{label}</span>

      <div className="row">
        {/* IZQUIERDA: bandera + código */}
        <div className="left">
          <img
            src={flag}
            alt={code}
            className="flag"
          />
          <span className="code">{code}</span>
        </div>

        {/* DERECHA: símbolo + monto */}
        <div className="right">
          <span className="symbol">{symbol}</span>

          <input
            className="amount"
            value={format(amount)}
            readOnly={!editable}
            onChange={(e) =>
              onChange?.(sanitize(e.target.value))
            }
            onFocus={onFocus}
          />
        </div>
      </div>
    </div>
  );
};